/* eslint-disable no-unused-vars */
export default (state = 0, action) => {
  switch (action.type) {
    case 'LOADING_START':
      return state + 1;
    case 'LOADING_END':
      return (state - 1) < 0 ? 0 : (state - 1);
    default:
      return state;
  }
};
